<template>
  <div>
    <div class="lds-facebook"  v-if="!loading"><div></div><div></div><div></div></div>
    <div class="row" v-if="loading">
     
      <div class="col-xl-4 col-lg-5 col-md-6">
        <user-card :user="userLogin">

        </user-card>
      </div>
      <div class="col-xl-8 col-lg-7 col-md-6">
        <!-- <edit-profile-form :user="userLogin">

        </edit-profile-form> -->
        <EditProfileFormDb :user="userLogin">

        </EditProfileFormDb>
        <!-- <app-credentials :user="dbuser">

        </app-credentials> -->
      </div>

    </div>
  </div>
</template>
<script>
import EditProfileForm from "./UserProfile/EditProfileForm.vue";
import EditProfileFormDb from "./UserProfile/EditProfileFormDb.vue";
import AppCredentials from "./UserProfile/AppCredentials.vue"
import UserCard from "./UserProfile/UserCard.vue";
import API from '../services/api.js';
export default {
  data(){
    return {
      user:{},
      dbuser:{},
      loading:false
    }
  },
  components: {
    EditProfileForm,
    EditProfileFormDb,
    UserCard,
    AppCredentials
  },
  mounted(){
    this.getAppProfile();
    this.getZoomProfile();
    if(localStorage.lang!=null) this.$i18n.locale=localStorage.lang; 
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.loggedIn;
    },
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  created(){
    if(!this.loggedIn) this.loggedOut
  },
  methods:{
    async getZoomProfile(){
      await API.get(`/user/${this.userLogin.email}/zoom`)
      .then(response => {
        if(response){
          if(response.status === 200){
            this.user = response.data.zoomProfile;
            this.loading = true
          }
        }
      })
    },
    async getAppProfile(){
      await API.get(`/user/${this.userLogin.email}/db`)
      .then(response => {
        if(response.status === 200){
          this.dbuser = response.data.response_data;
        }
      })
    },
    loggedOut(){
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  }
};
</script>
